interface Iprops {
  color?: string;
}

export const SpotIcon = ({ color }: Iprops) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.10791" cy="7.10791" r="7.10791" fill={color || "#F06D24"} />
  </svg>
);
